<template>
    <div v-wechat-title="title" style="height: 150vh">
        <div style="height: 100%">
            <el-row :span="2" style="display: flex; justify-content: center; align-items: center">
                <el-col :span="14" style="display: flex; justify-content: left; align-items: left">
                    <div class="block" style="float: left">
                        <item-input type="datetime-local" v-model="date1" style="width: 200px; height: 30px; font-size: 15px"></item-input>至
                        <item-input type="datetime-local" v-model="date2" style="width: 200px; height: 30px; font-size: 15px"></item-input>
                        <!-- <el-date-picker
                            v-show="checkedval && checkedval === true"
                            style="width: 280px"
                            size="mini"
                            :clearable="false"
                            v-model="value1"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            popper-class="popperClass"
                        >
                        </el-date-picker>
                        <el-date-picker
                            v-show="!checkedval || checkedval === false"
                            style="width: 280px"
                            size="mini"
                            :clearable="false"
                            v-model="value1"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            popper-class="popperClassdisplay"
                        >
                        </el-date-picker> -->
                    </div>
                </el-col>
                <el-col :span="5" style="isplay: flex; justify-content: left">
                    <div style="">
                        <span style="font-size: 14px">间隔：</span>
                        <el-input-number size="mini" style="width: 100px" v-model="controlsOptions" controls-position="right" :min="1" :max="maxnum"></el-input-number>
                    </div>
                </el-col>
                <el-col :span="2" style="display: flex; justify-content: right"> <el-button size="mini" @click="changeCheckBox('all')" type="primary">全选</el-button></el-col>
                <el-col :span="2" style="display: flex; justify-content: left; margin-left: 10px">
                    <div style="flex;justify-content: right;"><el-button size="mini" @click="changeCheckBox('Nathing')" type="primary">全不选</el-button></div>
                </el-col>
                <el-col :span="1"> </el-col>
            </el-row>
            <el-row><hr /></el-row>

            <div style="display: flex; overflow: hidden; height: 45%; overflow: scroll">
                <el-row :span="24">
                    <el-col v-for="item in listData" :span="8" :key="item.id" style="align-items: center">
                        <div style="display: flex; margin-top: 3px; align-content: space-between; justify-content: left; width: 100%">
                            <el-checkbox size="mini" v-model="item.check" style="font-size: 14px" :span="3">{{ item.name }}</el-checkbox>
                            <el-input size="mini" style="margin-left: 5px; width: 40%" v-model="item.text">{{ item.text }}</el-input>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="flex;margin-top:10%;position:absolute;bottom: 5%;width: 100%;">
                <el-row><hr /></el-row>
                <el-row style="display: flex; justify-content: right">
                    <el-col :span="24" style="display: flex; justify-content: right">
                        <div style="display: flex; flex-wrap: wrap; align-content: space-between; justify-content: space-between; padding-right: 40px">
                            <!-- <el-button type="primary" @click="deleteVitalSign">删除</el-button> -->
                            <el-button size="mini" type="primary" @click="clearVitalSign">清空</el-button>
                            <el-button size="mini" type="primary" @click="addVitalSign">添加</el-button>
                            <el-button
                                size="mini"
                                type="primary"
                                @click="extractVitalSign"
                                v-if="this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:vitaldata_extract`) != -1"
                                >提取</el-button
                            >
                            <el-button
                                size="mini"
                                type="primary"
                                @click="syncVitalSign"
                                v-if="this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:vitaldata_sync`) != -1"
                                >手动同步</el-button
                            >
                            <el-button size="mini" type="primary" @click="close">取消</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `CreateVitalSign`,
    data() {
        return {
            msg: `closeWindow`,
            // 页面标题
            title: `添加监护数据`,
            token: this.$route.query.token,
            surgery_id: this.$route.query.surgery_id,
            record_type: this.$route.query.record_type,
            // 默认时间
            date1: new Date(),
            date2: new Date(),
            // 默认加载数据
            listData: [],
            // 选中的数据
            checkData: [{
                id: {
                    type: Number
                },
                text: { type: Number },
                name: ``,
                check: {
                    type: Boolean
                }
            }],
            permissions: [],
            timeSet: this.$root.CreateVitalSignTimeSet,
            timeSetInfo: {
                controlsOptions: 5,
                maxnum: 15
            },
            // 时间间隔初始值
            controlsOptions: null,
            maxnum: null,
            checkedval: false
        }
    },
    // 打开页面加载时
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.InitData()
        this.checkData.shift()
    },
    mounted() {
        // 加载权限
        this.loadPermissions()
        let timeSetArr = this.timeSet && this.timeSet.split(`|`)
        if (timeSetArr && timeSetArr.length == 2) {
            this.timeSetInfo.controlsOptions = parseInt(timeSetArr[0])
            this.timeSetInfo.maxnum = parseInt(timeSetArr[1])
        }
        this.controlsOptions = this.timeSetInfo.controlsOptions
        this.maxnum = this.timeSetInfo.maxnum
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `sys_enums`, `active_ward`])
    },
    methods: {
        // 关闭方法
        close() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        // 清除input内容
        clearVitalSign() {
            this.listData.forEach(element => {
                element.text = null
            })
        },
        // 删除 某一时间段的监护数据
        deleteVitalSign() {
            var that = this
            that.$alert(`您功能暂未开发`, `提醒`, {
                dangerouslyUseHTMLString: true,
                type: `warning`
            })
        },
        // 全选or反选
        changeCheckBox(str) {
            if (str == `all`) {
                this.listData.forEach(element => {
                    element.check = true
                })
                console.log(this.listData)
            } else {
                this.listData.forEach(element => {
                    element.check = false
                })
            }
        },
        // 获取指定间隔时间段中的所有时间 返回数组
        getDateArray(startDate, endDate, step) {
            var that = this
            let space = step * 60 * 1000 // 间隔毫秒

            var endTime = new Date(endDate).getTime()
            var startTime = new Date(startDate).getTime()
            var mod = endTime - startTime // 相差时间
            // 间隔时间不能小于1分钟
            if (mod < space) {
                if (startTime != endTime) {
                    that.$alert(`小于间隔时间时,开始时间和结束时间必须相同`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                    return
                }

                // that.$alert(`您选的时间段太短了`, `提醒`, {
                //     dangerouslyUseHTMLString: true,
                //     type: `warning`
                // })
                // return
            }

            var dateArray = []
            // 向时间数组中插入每一条时间数据
            while (mod >= space) {
                var d = new Date()
                d.setTime(startTime + space)
                dateArray.push(that.$moment(d).format(`YYYY/MM/DD HH:mm:ss`))
                mod = mod - space
                startTime = startTime + space
            }
            var start = new Date(startDate).getTime()
            dateArray.unshift(that.$moment(new Date(start)).format(`YYYY/MM/DD HH:mm:ss`)) // 插入开头时间
            // 正序
            console.log(`dateArray`)
            console.log(dateArray)
            return dateArray.sort(function(a, b) {
                return Date.parse(b) - Date.parse(a)
            })
        },
        // 调用api添加监护数据
        addVitalSign() {
            let that = this
            this.checkData = _.filter(this.listData, function(c) {
                // ACIS-25369 调整添加监护数据控件 不需要勾选，捞取填写了内容的
                return c.text && c.text != ``
            })

            if (this.checkData.length == 0) {
                that.$alert(`请至少填写一项体征进行操作`, `提醒`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            try {
                this.checkData.forEach(d => {
                    if (d.text == null || d.text == ``) {
                        this.$message.error(`请录入监护数据！`)
                        throw new Error(`EndIterative`)
                    }
                    if (!parseFloat(d.text)) {
                        this.$message.error(`请录入数字！`)
                        throw new Error(`EndIterative`)
                    }
                })
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return
            }

            // 获取间隔时间 /min
            let step = this.controlsOptions
            // 获取开始时间
            var begin = this.$moment(this.date1).format(`YYYY/MM/DD HH:mm`)
            // 获取结束时间
            var end = this.$moment(this.date2).format(`YYYY/MM/DD HH:mm`)
            // 初始一个存放时间段的数组
            let sendData = []
            // 向选中数组中添加数据
            this.checkData.forEach(element => {
                this.getDateArray(begin, end, step).forEach(date => {
                    sendData.push({
                        biz_surgery_info_id: this.surgery_id,
                        data_dt: date,
                        recordType: this.record_type,
                        dic_physio_param_id: element.id,
                        value: parseFloat(element.text),
                        enum_record_type: this.record_type
                    })
                })
            })
            // 发送请求
            if (sendData.length < 1) {
                that.$alert(`请至少选择一条数据进行操作`, `提醒`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }

            // Monitor/CreateVitalSign 参数:1患者id 参数:2 监护数据
            let req = this.myaxios.post(`/api/Operation/Monitor/CreateVitalSign?surgery_id=${this.$route.query.surgery_id}`, sendData)
            req.then(data => {
                data.forEach(a => {
                    console.log(a)
                    let message = {
                        id: a.Id,
                        data_dt: this.$moment(a.DataDT).format(`YYYY/MM/DD HH:mm:ss`),
                        key: a.Dic_PhysioParam_Id,
                        value: a.Value
                    }
                    this.sendMessage(message)
                })
                this.close()
            }).catch(e => {
                console.log(e)
            })
        },
        // 提取
        extractVitalSign() {
            let that = this
            this.checkData = _.filter(that.listData, function(c) {
                return c.check
            }) || []
            // 获取开始时间
            var begin = that.$moment(that.date1).format(`YYYY/MM/DD HH:mm`)
            // 获取结束时间
            var end = that.$moment(that.date2).format(`YYYY/MM/DD HH:mm`)
            let sendData = {
                SurgeryInfoId: that.$route.query.surgery_id,
                RecordType: that.record_type,
                startTime: begin,
                endTime: end,
                PhysioParamIds: that.checkData && that.checkData.map(s => s.id) || []
            }
            // Monitor
            let req = this.myaxios.post(`/api/Operation/Monitor/ExtractVitalSign`, sendData)
            req.then(data => {
                console.log(data)
                if (data && data.length > 0) {
                    _.each(that.listData, d => {
                        let info = _.filter(data, function(c) {
                            return c.dic_physio_param_id == d.id
                        })
                        if (info && info.length > 0) {
                            d.text = info[0].value
                        }
                    })
                }
            }).catch(e => {
                console.log(e)
            })
        },
        // 手动同步
        syncVitalSign() {
            let that = this
            this.checkData = _.filter(that.listData, function(c) {
                return c.check
            }) || []

            // if (this.checkData.length == 0) {
            //     that.$alert(`请至少选择一个项目进行操作`, `提醒`, {
            //         dangerouslyUseHTMLString: true,
            //         type: `warning`
            //     })
            //     return
            // }

            // 获取间隔时间 /min
            let step = that.controlsOptions
            // 获取开始时间
            var begin = that.$moment(that.date1).format(`YYYY/MM/DD HH:mm`)
            // 获取结束时间
            var end = that.$moment(that.date2).format(`YYYY/MM/DD HH:mm`)
            let sendData = {
                SurgeryInfoId: that.$route.query.surgery_id,
                RecordType: that.record_type,
                startTime: begin,
                endTime: end,
                Interval: step,
                PhysioParamIds: that.checkData && that.checkData.map(s => s.id) || []
            }
            // Monitor
            let req = this.myaxios.post(`/api/Operation/Monitor/SyncVitalSign`, sendData)
            req.then(data => {
                data.forEach(a => {
                    console.log(a)
                    let message = {
                        id: a.Id,
                        data_dt: this.$moment(a.DataDT).format(`YYYY/MM/DD HH:mm:ss`),
                        key: a.Dic_PhysioParam_Id,
                        value: a.Value
                    }
                    this.sendMessage(message)
                })
                this.close()
            }).catch(e => {
                console.log(e)
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {})
        },
        sendMessage(message) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: message,
                    action: `refresh`
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        // 初始化Datalist
        InitData() {
            let data = {
                surgeryId: this.$route.query.surgery_id,
                step: this.$route.query.step,
                begin: this.$route.query.begin_time,
                end: this.$route.query.end_time,
                recordType: this.$route.query.record_type
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Operation/Monitor/GetMonitorBySurgery`, data)
                req.then(data => {
                    console.log(data)
                    this.listData = data.map(d => {
                        return {
                            id: d.id,
                            name: d.name,
                            text: ``,
                            check: false
                        }
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        setMaxNum() {
            // 获取开始时间
            var begin = this.$moment(this.date1)
            // 获取结束时间
            var end = this.$moment(this.date2)
            let newnum = end.diff(begin, `minutes`)
            let oldnum = this.timeSetInfo.maxnum
            if (newnum && oldnum > newnum && newnum != 0) {
                this.maxnum = newnum
            } else {
                this.maxnum = oldnum
            }
            if (this.controlsOptions > this.maxnum) {
                this.controlsOptions = this.maxnum
            }
        }
    },
    watch: {
        date2: function(newUrl, oldUrl) {
            this.setMaxNum()
        }
    }
}
</script>
<style scoped lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
.theme-dark .el-checkbox,
.theme-his-blue .el-checkbox {
    display: flex;
    justify-content: left;
    width: 100px;
    margin: 4px;
    padding: 4px;
    border-radius: 4px;
}
.theme-dark .el-checkbox__label,
.theme-his-blue .el-checkbox__label {
    font-size: 14px;
    color: #cccccc;
}
.mainRow {
    background: #f7f0de;
}
.ellipsis {
    width: 70%;
    height: 56px;
    line-height: 56px;
    border: 2px solid #dad9d5;
    border-radius: 14px;
    font-size: 14px;
    color: black;
    text-align: left;
    padding-left: 18px;
    cursor: pointer;
    background: #ffffff;
    margin: 0px auto;
}
.childellipsis {
    width: 70%;
    border: 2px solid #dad9d5;
    border-radius: 14px;
    font-size: 12px;
    color: black;
    text-align: left;
    padding-left: 18px;
    cursor: pointer;
    background: #ffffff;
    margin: 0px auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.selectedall {
    width: 100px;
}
.checked {
    background: #fda75e;
    border: 2px solid #fda75e;
    color: #ffffff;
}
.confirmworker {
    height: 120px;
    background-repeat: no-repeat;
    background-position: 50px 10px;
}

.confirmSign {
    display: block;
    font-size: 14px;
    font-weight: bold;
    color: blank;
    text-align: left;
    padding-left: 8px;
}
.Item {
    font-weight: normal;
    font-size: 14px;
    color: blank;
}
.childItem {
    // width: 62%;
    text-align: center;
    border: 1px solid #dad9d5;
    border-radius: 10px;
    padding-left: 10px;
    margin: 5px;
    height: 50px;
    line-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.worker {
    font-weight: normal;
    font-size: 14px;
    color: #fbb56f;
    margin-top: 10px;
}

.theme-dark .el-button,
.theme-his-blue .el-button {
    font-size: 14px;
    border-radius: 20px;
}
.theme-dark .el-dialog__body,
.theme-his-blue .el-dialog__body {
    padding: 0px 0px;
}
</style>
<style lang="less" >
.popperClassdisplay {
    display: none !important;
}
.popperClass {
    width: 480px !important;
    line-height: 15px !important;
    font-size: 10px !important;
    display: block !important;
    .el-picker-panel__body {
        min-width: 400px !important;
        font-size: 10px !important;
    }
    .el-picker-panel {
        line-height: 10px !important;
    }
    .el-date-range-picker__time-header {
        padding: 2px 2px 5px 2px !important;
    }
    .el-date-range-picker__header {
        height: 20px !important;
        font-size: 10px !important;
    }
    .el-picker-panel__icon-btn {
        margin-top: 0px !important;
    }
    .el-date-table th {
        padding: 0px !important;
    }
    .el-date-table td {
        padding: 0px !important;
        height: 20px !important;
        div {
            height: 20px !important;
        }
        span {
            width: 18px !important;
            height: 18px !important;
            line-height: 18px !important;
        }
    }
    .el-time-panel {
        width: 100px !important;
    }
    .el-date-range-picker__content {
        padding: 3px 5px 0px 5px !important;
    }
    .el-input--small {
        font-size: 10px !important;
    }
    .el-input--small .el-input__inner {
        height: 25px !important;
        line-height: 25px !important;
    }
    .el-date-range-picker__header div {
        font-size: 12px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/CreateVitalSign.vue